module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-17.3164300e.png";